import script from "./NwgCalendarEventWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./NwgCalendarEventWidget.vue?vue&type=script&setup=true&lang=js"

import "./NwgCalendarEventWidget.vue?vue&type=style&index=0&id=575ba134&lang=scss"

const __exports__ = script;

export default __exports__